import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';
import UIStrings from '@/Utils/UIStrings';

export const emailTemplateSchema = z.object({
    title: z.string().min(1, UIStrings.Required),
    regards: z.string().min(1, UIStrings.Required),
});

export type TemplateEditorForm = z.infer<typeof emailTemplateSchema>;

export const useEditEmailTemplate = () =>
    useForm<TemplateEditorForm>({
        resolver: zodResolver(emailTemplateSchema),
        mode: 'onSubmit',
    });

export const useEditEmailTemplateContext = () => useFormContext<TemplateEditorForm>();
